import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { GET } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';
import { FETCH_PROMOTIONS, FETCH_PROMOTIONS_FAIL, FETCH_PROMOTIONS_SUCCESS } from '../redux/Promotions';

function* FetchPromotionsFlow({ payload, }) {
  try {
    const params = { ad: { id: payload, }, };
    const endpoint = `${apiRoot}/promotions/`;
    yield put(SET_LOADER({ value: true, }));
    const response = yield call(apiCall, { method: GET, endpoint, params, });
    yield put(FETCH_PROMOTIONS_SUCCESS(response));
  } catch (error) {
    yield put(FETCH_PROMOTIONS_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* FetchPromotions() {
  yield takeLatest(FETCH_PROMOTIONS, FetchPromotionsFlow);
}
